import {observer} from "mobx-react";
import {useStore} from "../../stores/Store";
import {Box, Button, IconButton, Menu, MenuItem} from "@mui/material";
import ukFlag from "../../assets/img/united-kingdom-flag-png-xl.png";
import ruFlag from "../../assets/img/russia-flag.png";
import geFlag from '../../assets/img/german-flag.png'
import frFlag from '../../assets/img/france-flag.png'
import React, {useState} from "react";
import './LanguageChanger.css'
import langaugeImg from '../../assets/img/language-earth.png'

export default observer(function LanguageChanger(){
    const { LanguageStore } = useStore();
    const { currentLanguage, setCurrentLanguage } = LanguageStore;
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [isOpen, setIsOpen] = useState<boolean>(false)

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
        setIsOpen(true)
    }
    const handleClose = () => {
        setAnchorEl(null);
        setIsOpen(false);
    }

    const changeLanguage = (language: 'en' | 'ru' | 'fr' | 'ge') => {
        if(language === currentLanguage) return;
        setCurrentLanguage(language);
        handleClose();
    }

    return (
        <Box sx={{}}>
            <Button onClick={handleClick}>
                <img src={langaugeImg} width={60}/>
            </Button>
            <Menu open={isOpen} anchorEl={anchorEl} onClose={handleClose}>
                <MenuItem onClick={() => changeLanguage('ge')} >
                    <img src={geFlag} className={'languageFlag'}/>
                </MenuItem>
                <MenuItem onClick={() => changeLanguage('fr')} >
                    <img src={frFlag} className={'languageFlag'}/>
                </MenuItem>
                <MenuItem onClick={() => changeLanguage('ru')} >
                    <img src={ruFlag} className={'languageFlag'}/>
                </MenuItem>
                <MenuItem onClick={() => changeLanguage('en')}>
                    <img src={ukFlag} className={'languageFlag'}  />
                </MenuItem>
            </Menu>
        </Box>
    )
})